export interface GetProductListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetProductListPagingAndFilterResponseData
}

export interface GetProductListPagingAndFilterResponseData {
    items: GetProductListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetProductListPagingAndFilterResponseItem {
    productId: string
    companyId: string
    productGroupId: string
    name: string
    potTypeId: string
    isSubProduct: boolean
    minStock: number
    isCustomActive: boolean
    isSerialNoRequired: boolean
    isCompanyBarcodeRequired: boolean
    isKeylogxBarcodeRequired: boolean
    width: number
    length: number
    height: number
    volume: number
    desi: number
    weight: number
    productGroupName: string
    potTypeName: string
    productBarcodes: GetProductListPagingAndFilterResponseProductBarcode[]
    productSubProducts: GetProductListPagingAndFilterResponseProductSubProduct[]
    image: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetProductListPagingAndFilterResponseProductBarcode {
    productBarcodeId: string
    productId: string
    barcodeNo: string
    barcodeTypeId: string
    isCustomActive: boolean
    barcodeTypeName: string
}

export interface GetProductListPagingAndFilterResponseProductSubProduct {
    productSubProductId: string
    productId: string
    subProductId: string
    quantity: number
    subProductName: string
}

export const initialGetProductListPagingAndFilterResponseData: GetProductListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}